import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TopMenu from './Components/Layout/TopMenu';
import Home from './Components/Real_Estate/Home';
import Home2 from './Components/Real_Estate/Home2';
import Home3 from './Components/Real_Estate/Home3';
import Login from './Components/Login';
import PropertyList from './Components/Real_Estate/PropertyList';

function App() {
  return (
    <>
      <div>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<><TopMenu /><Home /></>} />
            <Route path="/home2" element={<><TopMenu /><Home2 /></>} />
            <Route path="/home3" element={<><TopMenu /><Home3 /></>} />
            <Route path="/PropertyList" element={<><TopMenu /><PropertyList /></>} />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
